export const languages = [
    { id: "de", label: "Deutsch" },
    { id: "en", label: "English" },
    { id: "fr", label: "Français" },
    { id: "es", label: "Español" },
    { id: "it", label: "Italiano" },
    { id: "pt", label: "Português" },
    { id: "zh", label: "中文" },
    { id: "ja", label: "日本語" },
];
